var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPriceListsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 97,
    height: 98,
    viewBox: "0 0 97 98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "price_lists") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "ah2uudhyua",
    x: 0,
    y: 0,
    width: 78,
    height: 98,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "icon base"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(9 2)",
    style: {
      fill: "none",
      opacity: 0.1
    },
    d: "M0 0h88v88H0z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#ah2uudhyua)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "file-invoice-dollar-solid",
    d: "M10 0A10.009 10.009 0 0 0 0 10v60a10.009 10.009 0 0 0 10 10h40a10.009 10.009 0 0 0 10-10V25H40a5 5 0 0 1-5-5V0zm30 0v20h20zM10 12.5a2.507 2.507 0 0 1 2.5-2.5h10a2.5 2.5 0 0 1 0 5h-10a2.507 2.507 0 0 1-2.5-2.5zm0 10a2.507 2.507 0 0 1 2.5-2.5h10a2.5 2.5 0 0 1 0 5h-10a2.507 2.507 0 0 1-2.5-2.5zm20 11.25a2.507 2.507 0 0 1 2.5 2.5v2.7a31.285 31.285 0 0 1 3.766.8 2.5 2.5 0 1 1-1.3 4.828 20.487 20.487 0 0 0-5.016-.828 7.394 7.394 0 0 0-3.688.859 2.179 2.179 0 0 0-1.266 2c0 .578.2 1.016 1.141 1.578a21.961 21.961 0 0 0 4.563 1.7l.078.016a23.189 23.189 0 0 1 5.672 2.281A6.987 6.987 0 0 1 40 58.156a7.311 7.311 0 0 1-3.578 6.5 10.883 10.883 0 0 1-3.922 1.422v2.672a2.5 2.5 0 0 1-5 0v-2.781a33.438 33.438 0 0 1-4.828-1.391 72.529 72.529 0 0 1-.969-.328 2.5 2.5 0 1 1 1.578-4.734c.391.125.75.25 1.109.375a19.458 19.458 0 0 0 5.672 1.359 6.884 6.884 0 0 0 3.7-.828 2.324 2.324 0 0 0 1.219-2.187 2.038 2.038 0 0 0-1.2-1.812 19.744 19.744 0 0 0-4.531-1.75l-.25-.079a23.833 23.833 0 0 1-5.437-2.141 6.661 6.661 0 0 1-3.547-5.828 7.161 7.161 0 0 1 3.718-6.325 11.487 11.487 0 0 1 3.766-1.362V36.25a2.507 2.507 0 0 1 2.5-2.5z",
    transform: "translate(9 6)",
    style: {
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceListsIcon);
export default __webpack_public_path__ + "static/media/price_lists_icon.8d6b1c7fab5e28af4bd06ace0be7a08d.svg";
export { ForwardRef as ReactComponent };